import React, {Component} from 'react';

class IconCurtainClosed extends Component {
  render() {
    const {color, size} = this.props;
const h = size === "lg"
  ? 128
  : 48;
const w = size === "lg"
  ? 128
  : 48;
    return (
      <i className="emoji">
        <svg style={{fill: color}} className="emoji" viewBox="-2 0 32 32" height={h} width={w} xmlns="http://www.w3.org/2000/svg">
          <path d="M 3 3 A 1.0001 1.0001 0 1 0 3 5 L 27 5 A 1.0001 1.0001 0 1 0 27 3 L 3 3 z M 3 7 L 3 26 C 3 26.552 3.448 27 4 27 L 14 27 L 14 8 C 13.448 8 13 7.552 13 7 L 12 7 C 12 7.552 11.552 8 11 8 C 10.448 8 10 7.552 10 7 L 9 7 C 9 7.552 8.552 8 8 8 C 7.448 8 7 7.552 7 7 L 6 7 C 6 7.552 5.552 8 5 8 C 4.448 8 4 7.552 4 7 L 3 7 z M 17 7 C 17 7.552 16.552 8 16 8 L 16 27 L 26 27 C 26.552 27 27 26.552 27 26 L 27 7 L 26 7 C 26 7.552 25.552 8 25 8 C 24.448 8 24 7.552 24 7 L 23 7 C 23 7.552 22.552 8 22 8 C 21.448 8 21 7.552 21 7 L 20 7 C 20 7.552 19.552 8 19 8 C 18.448 8 18 7.552 18 7 L 17 7 z"/>
        </svg>
      </i>
    )
  }
};

export default IconCurtainClosed;



// WEBPACK FOOTER //
// ./src/style/icon/IconCurtainClosed.js